import  gql  from 'graphql-tag'

export const SHARE_BALANCE_EMAIL = gql`mutation shareBalanceByEmail($input: ShareBalanceByEmailMutationInput!){
    shareBalanceByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;